import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes, faDollarSign } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        servicios: [],
        categorias: [],
        errors: []
    }
    changeValue = (e) => {
        const state = this.state.servicios;
        state[e.target.name] = e.target.value;
        this.setState({ servicios: state });
    };
    errorVerify(elemento) {
        return this.state.errors.indexOf(elemento) !== -1;
    }
    sendData = (e) => {
        e.preventDefault();
        const nombre = document.getElementById('nombre').value;
        const precio = document.getElementById('precio').value;
        const estado = document.getElementById('estado').value;
        var errors = [];
        if (!nombre) { errors.push("error_nombre"); }
        if (!precio) { errors.push("error_precio"); }
        if (!estado) { errors.push("error_estado"); }
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("servicios/update", formData)
            .then((dataResult) => {
                console.log(dataResult)
                Swal.close();
                Swal.fire(
                    'Servicios!',
                    dataResult.data.message,
                    'success'
                )
                this.props.history.push("/MasterServicios");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("servicios/view/" + this.props.match.params.id)
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (!status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ servicios: dataResult.data.servicio, load: '' });
            })
            .catch(console.log);
        authAxios.get("servicios/categorias")
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (!status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    categorias: dataResult.data.categorias
                });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, servicios, categorias } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR SERVICIO</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN DEL SERVICIO</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <label htmlFor="categoria">Categoria</label>
                                                    <select name="ID_CATEGORIA"
                                                        id="categoria"
                                                        value={servicios.ID_CATEGORIA}
                                                        options={servicios.ID_CATEGORIA}
                                                        className={((this.errorVerify("error_categoria")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione la Categoria</option>
                                                        {
                                                            categorias.map((itemCategorias) => (
                                                                <option key={itemCategorias.ID_CATEGORIA} value={itemCategorias.ID_CATEGORIA}>{itemCategorias.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Categoria</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <input type="hidden" name="id_servicio" value={this.props.match.params.id} />
                                                    <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={servicios.NOMBRE}
                                                        className={((this.errorVerify("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        placeholder="Nombre" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="precio">Precio</label>
                                                    <div className={((this.errorVerify("error_precio")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input type="number" name="precio" id="precio" defaultValue={servicios.PRECIO}
                                                            className={((this.errorVerify("error_precio")) ? "is-invalid" : "") + " form-control form-control-sm"} maxLength={20}
                                                            placeholder="PRECIO" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Precio</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="estado">Estado</label>
                                                    <select name="ESTADO"
                                                        id="estado"
                                                        value={servicios.ESTADO}
                                                        options={servicios.ESTADO}
                                                        className={((this.errorVerify("error_estado")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione el Estado</option>
                                                        <option value="0">ACTIVO</option>
                                                        <option value="1">INACTIVO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterServicios"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;